import Api from '../Api';

import { url } from './config';
import { CountryCode } from './types';

const api = new Api<CountryCode>(url);

export default api;
